<template>
    <div class="vx-relative">
        <div class="vx-absolute vx-left-4 vx-top-0 vx-w-px vx-h-full vx-bg-slate-300 lg:vx-left-12"></div>

        <group-collection-filter v-for="(filter, index) in filters"
            :key="filter.id"
            v-model="filters[index]"
            :filterIndex="index"
            @remove="removeFilter(index)"></group-collection-filter>

        <vx-box class="vx-relative vx-p-3 vx-inline-flex vx-space-x-2">
            <vx-button @click="add()"
                type="button"
                size="lg"
                color="primary"
                data-test="add">
                Add
                <font-awesome-icon :icon="faCirclePlus"></font-awesome-icon>
            </vx-button>
        </vx-box>
    </div>
</template>

<script setup>
import { VxBox, VxButton } from '@voxie/frontend-components'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { randomString } from '~/utils/string';
import GroupCollectionFilter from './GroupCollectionFilter.vue';

const filters = defineModel({
    type: Array,
    required: true,
    default: () => ([])
});

const add = () => {
    filters.value.push({
        id: randomString(),
        attribute: '',
        operator: '',
        key: '',
        values: [],
    })
}

const removeFilter = (index) => {
    filters.value.splice(index, 1);
    if (filters.value.length === 1) {
        add();
    }
}
</script>
